<template>
  <div>
    <div
      class="information-value flex flex-wrap"
      :title="`ระบบทะเบียนคนพิการ กรมส่งเสริมและพัฒนาคุณภาพชีวิตคนพิการ (DEP)${
        props.infoData?.linking_system?.find(i => i.system === 'DEP')?.updated_at
          ? '\nข้อมูล ณ วันที่: ' + props.infoData.linking_system.find(i => i.system === 'DEP').updated_at
          : ''
      }`"
    >
      <div class="inline-block w-9 h-9" v-show="isDEPConnected">
        <button
          class="bg-gray-100 cursor-pointer rounded-full text-center w-9 h-9 mr-2"
          @click="openConnectModal('DEP')" style="border:1px solid lightpink;"
        >
          <img
            class="connection-tags"
            :src="require('@/assets/images/icon/main/issue_based/disabled.png')"
          />
        </button>
      </div>
      <div class="text-center" v-show="!isDEPConnected">
        <a
          class="btn btn-primary"
          :class="{ 'pointer-events-none opacity-50': !props.isModal && depLoaded }"
          @click="openConnectModal('DEP')"
        >
          <span
            class="bg-gray-100 cursor-pointer rounded-full text-center w-5 mr-2"
          >
            <img
              class="connection-tags"
              :src="
                require('@/assets/images/icon/main/issue_based/disabled.png')
              "
            />
          </span>
          ตรวจสอบข้อมูลกับ DEP
        </a>
      </div>
    </div>

    <div
      id="edit-connect-modal-dep"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content bg-theme-39">
          <a
            data-dismiss="modal"
            href="javascript:;"
            @click="cancelConnectModalForm"
          >
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              ตรวจสอบข้อมูลกับ DEP
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
              <div v-show="infoData">
                <table id="datatable-comparing">
                  <thead>
                    <tr>
                      <th style="width: 26%;">รายการ</th>
                      <th style="width: 37%;">ข้อมูลเดิม (MSO-Logbook)</th>
                      <th style="width: 37%;">ข้อมูลจากระบบ DEP</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="info in infoToBeCompareDEP" :key="info.field">
                      <td class="label p-2">
                        <span v-html="info.label"></span>{{ info.label !== '' ? ':' : '' }}
                      </td>
                      <td
    class="rounded p-2 bg-gray-300"
    :style="info.field && info.field.startsWith('dis') && info.dep_text === '-' 
      ? 'border: 2px solid red;' 
      : ''"
  >
    {{ info.text }}
  </td>
                      <td 
                        class="rounded p-2" 
                        :class="{'bg-gray-300': info.text == info.dep_text, 'bg-[#dfaacc]': info.text != info.dep_text}"
                      >
                        {{ info.dep_text }}
                      </td>
                    </tr>
                    <tr><td class="label p-2"></td><td colspan="2"><span style=" color: red;">*</span> <span style="color: darkgrey;">ข้อมูลทั้งหมดถูกบันทึกลงระบบ MSO Logbook โดยอัตโนมัติ</span></td></tr>

                    <!-- <tr>
                      <td class="label p-2"></td>
                      <td></td>
                      <td style="justify-items: center;">
                        <div class="col-span-12 flex items-center justify-end">
                          <button
                            class="btn btn-primary"
                            @click="selectConnectModalForm"
                            data-dismiss="modal"
                          >
                            เลือกใช้ข้อมูลจาก DEP
                          </button>
                        </div>
                      </td>
                    </tr> -->
                  </tbody>
                </table>
                <hr class="col-span-12 mt-4" />
              </div>

              <div class="col-span-12 flex items-center mt-4 justify-end">
                <button
                  class="btn btn-primary ml-2"
                  data-dismiss="modal"
                  @click="cancelConnectModalForm"
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch, nextTick, inject } from "vue";
import { useStore } from "vuex";
import axios from "axios";
// import DEP from "@/views/member/container/DEP.vue"; // ถูกลบเพราะรวมโค้ดแล้ว
import dataJson from '@/data/health.json'
import Swal from "sweetalert2";
import cash from "cash-dom"; // ต้องมีการ import หรือ define global variable 'cash'
const codeMapping = {
    "12": "DA1",
    "13": "DA2",
    "14": "DA3",
    "15": "DA4",
    "16": "DA5",
    "17": "DA6",
    "18": "DA7"
};
// **********************************************
// ** โค้ดส่วน DEP Component (ไฟล์ 2) - Logic **
// **********************************************

// ** Variables/Functions from DEP Component (ไฟล์ 2) **
const selectConnectModalForm = async () => {
    const token = store.getters["userAuth/getToken"];

  swalCustom.fire({
    html: "ยืนยันบันทึกข้อมูลจาก ระบบทะเบียนคนพิการ (DEP)",
    icon: "info",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: 'ตกลง',
    cancelButtonText: 'ยกเลิก',
    allowOutsideClick: false,
    allowEscapeKey: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // ** ส่วนนี้ถูก Commented-out ในโค้ดต้นฉบับ ซึ่งควรจะทำการ PUT API **
        // let update_data = {
        //    // ... ข้อมูลที่จะอัพเดท
        // };
        // const config = {
        //   url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
        //   method: "PUT",
        //   headers: {
        //      Authorization: `Bearer ${token}`,
        //      "Content-Type": `application/json; charset=utf-8`,
        //   },
        //   data: {
        //      update: update_data
        //   }
        // };
        // const res = await axios(config);
        
        // ** จำลองการตอบกลับสำเร็จ เนื่องจากโค้ด API ถูก Commented-out **
        const res = { status: 200 }; 

        if (res.status === 200 || res.status === 201) {
          if (refreshMemberData) {
            await refreshMemberData();
          }

          await new Promise(resolve => setTimeout(resolve, 300));
          Swal.close();
          await swalCustom.fire({
            html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลสำเร็จ</div>`,
            icon: 'success',
            timer: 2000,
            confirmButtonText: "ปิด",
          });
        } else {
          throw new Error('Failed to update member');
        }
      } catch (error) {
        console.error("Error updating member from DEP:", error);
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          confirmButtonText: "ปิด",
        });
      }
    }
  }).catch((error) => {
    console.error("DEP: Error in selectConnectModalForm:", error);
  });
};
// **********************************************
// ** สิ้นสุด โค้ดส่วน DEP Component (ไฟล์ 2) - Logic **
// **********************************************


const store = useStore();
const generateLogoHTML = ref("");
const cancelData = ref(false);
const openModalStatus = ref(false);
const depLoaded = ref(false);
const infoToBeCompareDEP = ref([]);
const dep_data = ref({});
const img_connect_logo = ref("");
const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  infoData: Object,
  infoDataId: String,
  isModal: Boolean,
  nationalId: String,
  form: Object
});

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});
const emit = defineEmits(["update-profile", "dep-no-data"]);
const refreshMemberData = inject("refreshMemberData", null);
const isDEPConnected = computed(() => {
    const isConnected = props.infoData?.linking_system?.some(item => {
        return (typeof item === 'object' && item !== null) 
            ? item.system === 'DEP' 
            : item === 'DEP';
    });
    return !!isConnected;
});
const checkAgeLTE5Y11M = (formBirthdate) => {
  const birthDate = new Date(formBirthdate);

  const today = new Date();
  const cutoffDate = new Date(birthDate);
  cutoffDate.setFullYear(birthDate.getFullYear() + 6);
  cutoffDate.setDate(cutoffDate.getDate() - 1);

  return today <= cutoffDate;
};

const cancelConnectModalForm = async () => {
  // cash('#edit-member-modal').modal('hide') // ถูก Commented-out จากโค้ดเดิม
  cash("#edit-connect-modal-dep").modal("hide");
  cancelData.value = true;
  openModalStatus.value = false;
};

const openConnectModal = async (link) => {
  if (!props.isModal && depLoaded.value) {
    swalCustom.fire({
      text: "ข้อมูลจากระบบ DEP ถูกเติมในแบบฟอร์มเรียบร้อยแล้ว",
      confirmButtonText: "ปิด",
    });
    return;
  }

  let _res = await CompareDataDEP();

  if (_res === "error") {
    return;
  }
  if (_res === "no_data" || _res === undefined) {
    emit("dep-no-data");
    swalCustom.fire({
      text: "ไม่พบข้อมูลจากระบบ DEP",
      confirmButtonText: "ปิด",
    });
    return;
  }
  if (_res === false) {
    swalCustom.fire({
      text: "ไม่พบการเปลี่ยนแปลงข้อมูลจากระบบ DEP",
      confirmButtonText: "ปิด",
    });
    return;
  }
  if (!props.isModal) {
    depLoaded.value = true;
  }

  if (props.isModal) {
    await cash("#edit-connect-modal-dep").modal("show");
  }
  // putLinkingSystem("DEP");
  openModalStatus.value = true;
  cancelData.value = false;
};
// const checkPWDCardStatus = (expireDateStr) => {
//     if (!expireDateStr) {
//         return "ไม่มีบัตร";
//     }

//     // แปลงวันที่ (สมมติว่าเป็น format DD-MM-YYYY หรือ DD-MM-BBBB)
//     const parts = expireDateStr.split('-');
//     // แปลงปี พ.ศ. เป็น ค.ศ. (สมมติว่าปีเกิน 2500 คือปี พ.ศ.)
//     const year = parseInt(parts[2]) > 2500 ? parseInt(parts[2]) - 543 : parseInt(parts[2]);
//     const expireDate = new Date(year, parseInt(parts[1]) - 1, parseInt(parts[0]));
    
//     const today = new Date();
//     // ตั้งค่าเวลาของ today ให้เป็น 00:00:00 เพื่อเปรียบเทียบแค่ในระดับวัน
//     today.setHours(0, 0, 0, 0); 
    
//     console.log(today)
//     console.log(expireDate)
//     console.log(expireDate >= today)
//     // ถ้าวันที่หมดอายุมากกว่าหรือเท่ากับวันนี้ แปลว่าบัตรยังมีอายุ
//     if (expireDate >= today) {
//         return "มีบัตร";
//     } else {
//         return "ไม่มีบัตร";
//     }
// };
const isAllDataMatched = async (compareArray) => {
  return compareArray.every((item) => {
    // แปลงค่าเป็น String และ trim ช่องว่างก่อนเปรียบเทียบ
    const textA = String(item.text || "").trim();
    const textB = String(item.dep_text || "").trim();
    return textA === textB;
  });
};

const CompareDataDEP = async (link) => {
  infoToBeCompareDEP.value = [];
  let personCode =
    props.infoData?.idCardNumber ??
    props.infoData?.national_id ??
    props.nationalId ??
    "";
  if (!personCode && props.infoDataId) {
    try {
      const token = store.getters["userAuth/getToken"];
      const res = await axios({
        url: `${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json; charset=utf-8"
        },
        data: { memberId: props.infoDataId }
      });
      personCode = res.data?.national_id ?? res.data?.idCardNumber ?? "";
    } catch (e) {
      console.warn("[DEP] ดึงข้อมูลสมาชิกไม่สำเร็จ", e);
    }
  }
  if (!personCode) {
    console.warn("[DEP] ไม่พบเลขบัตรประชาชน (person_code) สำหรับเรียก API", {
      hasInfoData: !!props.infoData,
      hasInfoDataId: !!props.infoDataId,
      nationalIdProp: props.nationalId
    });
    return;
  }
  const config = {
    url: `https://mso-logbook.m-society.go.th/api/dc/dep?person_code=${personCode}`,
    method: "GET"
  };
  try {
    const res = await axios(config);
    const data = res?.data;
    const isEmpty =
      data == null ||
      data === "" ||
      (Array.isArray(data) && data.length === 0) ||
      (typeof data === "object" && !Array.isArray(data) && Array.isArray(data?.data) && data.data.length === 0);
    if (isEmpty) {
      dep_data.value = {};
      return "no_data";
    }
    dep_data.value = Array.isArray(data) ? (data[0] ?? {}) : (data?.data?.[0] ?? data ?? {});
  } catch (error) {
    console.log("[DEP] API error", error);
    return "error";
  }
  // ** ข้อมูลจำลองจาก DEP **
  // dep_data.value = {
  //   MAIMAD_AGE: "MAIMAD_AGE",
  //   CURATOR_PREFIX_NAME: "นางสาว",
  //   CURATOR_FIRST_NAME: "ชัยระวี",
  //   CURATOR_LAST_NAME: "ชีระวัน",
  //   CURATOR_PERSON_CODE: "911",
  //   CURATOR_RELATION_CODE: "บลัก",
  //   CURATOR_RELATION_NAME: "CURATOR_RELATION_NAME",
  //   CURATOR_RELATION_OTHER: "CURATOR_RELATION_OTHER",
  //   DEFORMID: "12",
  //   DEFORMNAME: "ความพิการทางการมองเห็น",
  //   CARD_ISSUE_DATE: "19-09-2540", 
  //   CARD_EXPIRE_DATE: "19-09-2569",
  //   PERMIT_DATE: "19-09-2540",
  //   PERSON_SUBTYPE: "Current"
  //   // is_disabled: "พิการ", PERSON_SUBTYPE
  //   // have_pwd_card: "ไม่มีบัตร",
  //   // disability:[{code: "DA2", desc: "พิการทางการได้ยินหรือสื่อความหมาย"},{code: "DA3", desc: "พิการทางการเคลื่อนไหวหรือทางร่างกาย"}]
  // };
  //PERSON_SUBTYPE ดูว่าพิการไหม ถ้าไม่พิการแล้ว ความพิการเดิมคืออะไรเคยมีใน logbook ไหมถ้ามีเอาออก
  //PERSON_SUBTYPE ดูว่าพิการไหม ถ้าไม่ ก็ไม่ต้องเก็บ
  //inking_system ก็ระบุเป็น DEP ไว้ต่อให้ไม่พิการแล้ว
   
  // let _dep_data = dep_data.value;
  // _dep_data.have_pwd_card = checkPWDCardStatus(_dep_data.CARD_EXPIRE_DATE);
  // console.log( _dep_data.have_pwd_card)
  // _dep_data.is_disabled = _dep_data.PERSON_SUBTYPE === "PERSON_SUBTYPE"?1:0;
  const checkPWDCardStatus = (subtypeCode) => {
  // อ้างอิงเงื่อนไขจากคอลัมน์ "กลุ่มบัตร"
  const mapping = {
    'Current': 'มีบัตร',
    'InIDP': 'มีบัตร',
    'InCentral': 'มีบัตร',
    'Expire': 'บัตรหมดอายุ',
    // กลุ่มที่ไม่มีบัตรตามตาราง
    'Out': 'ไม่มีบัตร',
    'Normal': 'ไม่มีบัตร',
    'Well': 'ไม่มีบัตร',
    'Cancel': 'ไม่มีบัตร',
    'NoCard': 'ไม่มีบัตร',
    'IsNot': 'ไม่มีบัตร',
    'Wait': 'ไม่มีบัตร',
    'Caution': 'ไม่มีบัตร',
    'NoRequest': 'ไม่มีบัตร',
    'Again': 'ไม่มีบัตร'
  };
  
  return mapping[subtypeCode] || 'ไม่มีบัตร'; // Default เป็นไม่มีบัตรหากไม่พบรหัส
};

let _dep_data = dep_data.value;
const subtype = _dep_data.PERSON_SUBTYPE;
_dep_data.have_pwd_card = checkPWDCardStatus(subtype);
// รายชื่อกลุ่มที่ระบุชัดเจนว่า "ไม่พิการ" ในตาราง
const nonDisabledGroup = ['Normal', 'Well', 'Cancel', 'IsNot', 'Caution'];
if (nonDisabledGroup.includes(subtype)) {
    // กลุ่มที่ต้องเซ็ตเป็น 0 แน่นอนตามเงื่อนไขสีแดงในตาราง
    _dep_data.is_disabled = 0;
    _dep_data.disability = null;
    _dep_data.have_pwd_card = null; // บางกรณีให้เซ็ตเป็น null ตามหมายเหตุ
} 
else if (['Current', 'Wait', 'Expire', 'InIDP', 'InCentral'].includes(subtype)) {
    // กลุ่มที่ระบุว่า "พิการ" ชัดเจน
    _dep_data.is_disabled = 1;
} 
else {
    // กลุ่มที่เป็นเครื่องหมาย "-" (Out, NoCard, NoRequest, IncFLName, Again, NoComplete)
    // เงื่อนไข: ถ้ามี deformname มาให้เปลี่ยนเป็นพิการ (1) ถ้าไม่มีให้คงสภาพเดิม (เช็คจากค่าเดิมหรือ 0)
    if (_dep_data.deformname) {
        _dep_data.is_disabled = 1;
    } else {
        // หากไม่มีข้อมูลความพิการเดิม ให้ถือว่าเป็น 0 ตามระบบ MSO
        _dep_data.is_disabled = _dep_data.is_disabled || 0; 
    }
}

console.log("Status:", _dep_data.have_pwd_card, "Is Disabled:", _dep_data.is_disabled);

const rawDeformId = _dep_data.DEFORMID;
if (rawDeformId) {
    const idArray = rawDeformId.split("/");

    const mappedDisability = idArray.map(id => {
        const targetCode = codeMapping[id];
        const found = dataJson.health.disability.find(item => item.option.code === targetCode);
        if (found) {
            return {
                code: found.option.code,
                desc: found.option.desc
            };
        }
        return null;
    }).filter(item => item !== null);
    dep_data.value.disability = mappedDisability;
} else {
    dep_data.value.disability = [];
}
    // dep_data.value.disability = [{code: _dep_data.DEFORMID, desc: _dep_data.DEFORMNAME}]
console.log(_dep_data)
  infoToBeCompareDEP.value = [
    {
      field: "title",
      label: "ความพิการ",
      text: props.infoData?.is_disabled ? 'พิการ': 'ไม่พิการ' || "-",
      dep_text: _dep_data?.is_disabled === 1?'พิการ':'ไม่พิการ' || "-",
    },
    {
      field: "name",
      label: "มีบัตรประจำตัวคนพิการ",
      text: props.infoData?.have_pwd_card == 1 ? 'มีบัตร':props.infoData?.have_pwd_card == 2 ? 'บัตรหมดอายุ':'ไม่มีบัตร' || "-",
      dep_text: _dep_data?.have_pwd_card || "-",
    }
  ];

let mainData;
let compareData;
let mainDataKey = 'text';
let compareDataKey = 'dep_text';
let data1 = props.infoData?.disability;
let data2 = dep_data.value?.disability;
if(!data1 || data1 == null){
data1 =[]
}
console.log(props.infoData)
console.log(data1)
console.log(data2)
// if (data1.length >= data2.length) {
//     mainData = data1;
//     compareData = data2;
// } else {
//     mainData = data2;
//     compareData = data1;
//     mainDataKey = 'dep_text';
//     compareDataKey = 'text';
// }
// mainData?.forEach((item, index) => {
//     const matchInCompare = compareData?.find(
//         (compItem) => compItem.code === item.code
//     );

//     const mainText = item.desc;
//     const compareText = matchInCompare ? matchInCompare.desc : "-";
//     let _l = `ประเภทความพิการ`
//     if(index > 0){
// _l = ''
//     }
//     let resultObject = {
//         field: `dis${index + 1}`,
//         label: _l,
//         [mainDataKey]: mainText, 
//         [compareDataKey]: compareText 
//     };
    
//     infoToBeCompareDEP.value.push(resultObject);
// });
const allCodes = Array.from(new Set([
    ...data1.map(i => i.code),
    ...data2.map(i => i.code)
]));
allCodes.forEach((code, index) => {
    const itemMSO = data1.find(i => i.code === code); // data1 คือ MSO
    const itemDEP = data2.find(i => i.code === code); // data2 คือ DEP
    const textMSO = itemMSO ? itemMSO.desc : "-";
    const textDEP = itemDEP ? itemDEP.desc : "-";
    let _l = (index === 0) ? "ประเภทความพิการ" : "";
    let resultObject = {
        field: `dis${index + 1}`,
        label: _l,
        text: textMSO,      // ข้อมูลจาก MSO (data1)
        dep_text: textDEP   // ข้อมูลจาก DEP (data2)
    };

    infoToBeCompareDEP.value.push(resultObject);
});
const depFieldsMap = [
    { 
        propKey: 'maimad_age',          // Key ของ DEP ที่ Mapping แล้ว (dep_data.value)
        depKey: 'MAIMAD_AGE',               // Key ของ App Data (props.infoData) -> ตัวพิมพ์ใหญ่
        label: 'อายุ ณ วันออกบัตรครั้งแรก' 
    },
    { 
        propKey: 'curator_prefix_name', 
        depKey: 'CURATOR_PREFIX_NAME', 
        label: 'คำนำหน้าชื่อผู้ดูแล' 
    },
    { 
        propKey: 'curator_first_name', 
        depKey: 'CURATOR_FIRST_NAME', 
        label: 'ชื่อจริงผู้ดูแล' 
    },
    { 
        propKey: 'curator_last_name', 
        depKey: 'CURATOR_LAST_NAME', 
        label: 'นามสกุลผู้ดูแล' 
    },
    { 
        propKey: 'curator_person_code', 
        depKey: 'CURATOR_PERSON_CODE', 
        label: 'เลขบัตรผู้ดูแล' 
    },
    { 
        propKey: 'curator_relation_code', 
        depKey: 'CURATOR_RELATION_CODE', 
        label: 'รหัสความสัมพันธ์ผู้ดูแล' 
    },
    { 
        propKey: 'curator_relation_name', 
        depKey: 'CURATOR_RELATION_NAME', 
        label: 'ความสัมพันธ์' 
    },
    { 
        propKey: 'curator_relation_other', 
        depKey: 'CURATOR_RELATION_OTHER', 
        label: 'ความสัมพันธ์อื่นๆ' 
    },
    { 
        propKey: 'card_issue_date', 
        depKey: 'CARD_ISSUE_DATE', 
        label: 'วันที่ออกบัตรคนพิการ' 
    },
    { 
        propKey: 'card_expire_date', 
        depKey: 'CARD_EXPIRE_DATE', 
        label: 'วันที่บัตรคนพิการหมดอายุ' 
    },
    { 
        propKey: 'permit_date', 
        depKey: 'PERMIT_DATE', 
        label: 'วันที่อนุมัติขึ้นทะเบียนคนพิการ' 
    },
    { 
        propKey: 'person_subtype', 
        depKey: 'PERSON_SUBTYPE', 
        label: 'สถานะบุคคล' 
    },
];

const mapSubtypeToThai = (code) => {
    const mapping = {
        Current: 'คนพิการจดทะเบียน',
        Out: 'เสียชีวิต',
        Normal: 'หายจากความพิการ',
        Well: 'ยังไม่เข้าเกณฑ์คนพิการ',
        Cancel: 'ยกเลิก',
        NoCard: 'ไม่ประสงค์มีบัตรประจำตัวคนพิการ',
        IsNot: 'ไม่ได้เป็นคนพิการ',
        Wait: 'อยู่ระหว่างการอนุมัติจากนายทะเบียน...',
        Expire: 'บัตรหมดอายุ',
        Caution: 'บุคคลที่อาจไม่เข้าเกณฑ์ความพิการ',
        NoRequest: 'ไม่มีแบบคำขอมีบัตร',
        IncFLName: 'ชื่อ-นามสกุลไม่ตรงกับกรมการปกครอง',
        Again: 'แบบคำขอไม่อนุมัติ จนท.ต้องบันทึกคำขอใหม่',
        NoComplete: 'ข้อมูลไม่สมบูรณ์',
        InIDP: 'อยู่ในสถานสงเคราะห์ฯ ของ พก.',
        InCentral: 'อยู่ในทะเบียนบ้านกลาง',
    };

    if (!code || code === '-') {
        return '-';
    }

    return mapping[code] || code;
};

// วนลูปเพื่อสร้างและเพิ่มออบเจกต์เปรียบเทียบ
for (const fieldMap of depFieldsMap) {
    if (fieldMap.propKey === 'curator_relation_code') {
        continue;
    }
    const rawTextValue = props.infoData?.dep?.[fieldMap.propKey] || "-";
    
    // ข้อมูลจากฝั่ง DEP (dep_data.value)
    const rawDepTextValue = dep_data.value?.[fieldMap.depKey] || "-";

    const isPersonSubtype = fieldMap.propKey === 'person_subtype';
    const textValue = isPersonSubtype ? mapSubtypeToThai(rawTextValue) : rawTextValue;
    const depTextValue = isPersonSubtype ? mapSubtypeToThai(rawDepTextValue) : rawDepTextValue;
    
    infoToBeCompareDEP.value.push({
        field: fieldMap.propKey,
        label: fieldMap.label,
        text: textValue, 
        dep_text: depTextValue // ข้อมูลใหม่จาก DEP
    });
}
  const allDataMatch = await isAllDataMatched(infoToBeCompareDEP.value);
  if (allDataMatch) {
    return false;
  }
    if(!props.isModal){  console.log('หน้าเพิ่มสมาชิก');
//เติมข้อมูล
let depData;
if(_dep_data.is_disabled === 0){
     depData = {
linking_system: [{system: "DEP", updated_at: new Date().toISOString().split('T')[0]}],
        is_disabled: _dep_data.is_disabled
    }
}else{
 depData = {
linking_system: [{system: "DEP", updated_at: new Date().toISOString().split('T')[0]}],
      is_disabled: _dep_data.is_disabled,
      have_pwd_card: _dep_data.have_pwd_card === "มีบัตร" ? 1 : _dep_data.have_pwd_card === "บัตรหมดอายุ"?2 :0,
      disability: data2
    };
}
depData.dep={};
depData.dep.maimad_age= _dep_data.MAIMAD_AGE
    depData.dep.curator_prefix_name= _dep_data.CURATOR_PREFIX_NAME
    depData.dep.curator_first_name= _dep_data.CURATOR_FIRST_NAME
    depData.dep.curator_last_name= _dep_data.CURATOR_LAST_NAME
    depData.dep.curator_person_code= _dep_data.CURATOR_PERSON_CODE
    depData.dep.curator_relation_code= _dep_data.CURATOR_RELATION_CODE
   depData.dep.curator_relation_name= _dep_data.CURATOR_RELATION_NAME
    depData.dep.curator_relation_other= _dep_data.CURATOR_RELATION_OTHER
    depData.dep.card_issue_date= _dep_data.CARD_ISSUE_DATE
    depData.dep.card_expire_date= _dep_data.CARD_EXPIRE_DATE
    depData.dep.permit_date= _dep_data.PERMIT_DATE
    depData.dep.person_subtype =_dep_data.PERSON_SUBTYPE
    emit('data-loaded', depData);
    return true;
    } else{
  //       let editDepData={};
  //       editDepData.dep ={}
  // editDepData.dep.maimad_age= _dep_data.MAIMAD_AGE
  //   editDepData.dep.curator_prefix_name= _dep_data.CURATOR_PREFIX_NAME
  //   editDepData.dep.curator_first_name= _dep_data.CURATOR_FIRST_NAME
  //   editDepData.dep.curator_last_name= _dep_data.CURATOR_LAST_NAME
  //   editDepData.dep.curator_person_code= _dep_data.CURATOR_PERSON_CODE
  //   editDepData.dep.curator_relation_code= _dep_data.CURATOR_RELATION_CODE
  //  editDepData.dep.curator_relation_name= _dep_data.CURATOR_RELATION_NAME
  //   editDepData.dep.curator_relation_other= _dep_data.CURATOR_RELATION_OTHER
  //   editDepData.dep.card_issue_date= _dep_data.CARD_ISSUE_DATE
  //   editDepData.dep.card_expire_date= _dep_data.CARD_EXPIRE_DATE
  //   editDepData.dep.permit_date= _dep_data.PERMIT_DATE
  //   editDepData.dep.person_subtype =_dep_data.PERSON_SUBTYPE
  //    let depData = {
  //     is_disabled: _dep_data.is_disabled,
  //     have_pwd_card: _dep_data.have_pwd_card === "มีบัตร" ? 1 : 0,
  //     disability: data2
  //   };
  //     emit('data-loaded', depData);
  let editDepData = { dep: {} };
if(_dep_data.is_disabled === 0){
  editDepData = null
}else{
depFieldsMap.forEach(fieldMap => {
    editDepData.dep[fieldMap.propKey] = _dep_data[fieldMap.depKey];
});
}


// จากนั้นค่อยนำไปประกอบร่าง
let depData = {
    is_disabled: _dep_data.is_disabled,
    have_pwd_card: _dep_data.have_pwd_card === "มีบัตร" ? 1 : _dep_data.have_pwd_card === "บัตรหมดอายุ"?2 :0,
    disability: data2
};
if(_dep_data.is_disabled === 0){
depData.disability = null
}

emit('data-loaded', { ...editDepData, ...depData });

    const hasDEP = props.infoData?.linking_system?.some(item => 
    (typeof item === 'object' ? item.system : item) === "DEP"
    );
    if (!hasDEP) {
      putLinkingSystem("DEP", { ...editDepData, ...depData });
    } else {
      putLinkingSystem("", { ...editDepData, ...depData });
    }
    }

  if (allDataMatch) {
    return false;
  } else {
    return true;
  }
};
const putLinkingSystem = async (link, editDepData) => {
  console.log(props.infoData);
  let get_linking_system = [];
  
  // สร้าง Object รูปแบบใหม่
  const newSystemEntry = {
    system: link,
    updated_at: new Date().toLocaleDateString('sv-SE') // ได้ "2026-02-06"
  };

  if (props.infoData && props.infoData.linking_system) {
    const originalSystems = props.infoData.linking_system;

    // หา Index ของระบบเดิม (ถ้ามี)
    const existingIndex = originalSystems.findIndex(item => 
      (typeof item === 'object' ? item.system : item) === link
    );

    if (existingIndex !== -1) {
      // ถ้ามีอยู่แล้ว ให้ copy มาทั้งหมด (หรือจะอัปเดตวันที่ใหม่ก็ได้)
      get_linking_system = [...originalSystems];
      get_linking_system[existingIndex] = newSystemEntry; // เปิดบรรทัดนี้ต้องการอัปเดตวันที่ด้วย
    } else {
      // ถ้ายังไม่มี และ link ไม่ว่าง ให้เพิ่ม Object ใหม่เข้าไป
      get_linking_system = link !== "" 
        ? [...originalSystems, newSystemEntry] 
        : [...originalSystems];
    }
  } else {
    // ถ้าไม่มีข้อมูลเดิมเลย และมีการส่งชื่อระบบมา
    get_linking_system = link !== "" ? [newSystemEntry] : [];
  }

  // นำข้อมูล linking_system ใส่กลับเข้าไปใน data ที่จะส่ง
  if (link !== "") {
    editDepData.linking_system = get_linking_system;
  }

  const token = store.getters["userAuth/getToken"];
  const config = {
    url: `${process.env.VUE_APP_BASE_API}member/${props.infoDataId}`,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": `application/json; charset=utf-8`,
    },
    data: {
      update: editDepData
    }
  };

  axios(config).then((res) => {
    emit("update-profile");
    if (typeof refreshMemberData === "function") {
      refreshMemberData();
    }
  });
};
// const putLinkingSystem = async (link,editDepData) => {
//   console.log(props.infoData);
//   let get_linking_system = [];
//   if (props.infoData && props.infoData.linking_system) {
//     const originalSystems = props.infoData.linking_system;

//     if (originalSystems.includes(link)) {
//       get_linking_system = [...originalSystems];
//     } else {
//       get_linking_system = [...originalSystems, link];
//     }
//   } else {
//     get_linking_system = [link];
//   }
//   if(link != ""){
//   editDepData.linking_system = get_linking_system
//   }
//   const token = store.getters["userAuth/getToken"];
//   const config = {
//     url: `${process.env.VUE_APP_BASE_API}member/${props.infoDataId}`,
//     method: "PUT",
//     headers: {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": `application/json; charset=utf-8`,
//     },
//     data: {
//       update: editDepData
//     }
//   };
//   axios(config).then((res) => {
//     emit("update-profile");
//     if (refreshMemberData) {
//             refreshMemberData();
//           }
//   });
// };

const rawDataToText = (data, dataType) => {
  switch (dataType) {
    case "vital_status":
      switch (data) {
        case 1:
          return "มีชีวิตอยู่";
        case 0:
          return "เสียชีวิต";
        default:
          console.log(
            `สถานะการมีชีวิตต้องเป็นตัวเลข 1 หรือ 0 เท่านั้น แต่นี่เป็น ${data} (เป็น string ก็ไม่ได้)`
          );
          return "ข้อมูลไม่ตรง format";
      }
    case "birthdate":
      if (data) {
        return new Date(data).toLocaleDateString("th-TH");
      } else {
        return "-";
      }
    default:
      return data;
  }
};
</script>

<style>
#datatable-comparing {
  border-collapse: separate;
  border-spacing: 5px;
  width: 100%;
}
.label {
  vertical-align: text-top;
}
@media screen and (max-width: 372px) {
  /* 1. ซ่อน Header */
  #datatable-comparing thead {
    display: none;
  }

  /* 2. ทำให้แถวเป็นบล็อกแนวตั้ง */
  #datatable-comparing tr {
    display: block;
    margin-bottom: 10px;
    border: 1px solid #ccc;
  }

  /* 3. ทำให้เซลล์เป็นบล็อกแนวตั้ง และเพิ่ม Label */
  #datatable-comparing td {
    display: block;
    text-align: right;
    padding-left: 50%; /* เว้นที่ให้ Label */
    position: relative;
  }

  /* 4. ใช้ ::before เพื่อใส่ชื่อคอลัมน์เป็น Label */
  #datatable-comparing td::before {
    content: attr(data-label); /* ดึง Label จาก Attribute ใน HTML */
    position: absolute;
    left: 6px;
    font-weight: bold;
  }
}
</style>